module.exports = __webpack_public_path__ + "img/instruction4.fdf86e3c.png";